module.exports = __webpack_public_path__ + "media/packs/src/assets/images/star-dc9d433cbfd360495d12bcd30a51e981.png";